<template>
  <semipolar-spinner
    ref="spinner"
    :animation-duration="2000"
    :size="65"
    color="#2C2E3E"
    style="position: absolute; left: 47%; top: 40%"></semipolar-spinner>
</template>

<script>
  import { SemipolarSpinner  } from 'epic-spinners'

  export default {
    components: {
      SemipolarSpinner
    }
  }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/LoadingScreen.vue